module.exports = "<div class=\"container-block\">\n  <div class=\"profile-image-block fast-fade-in home-image\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main